import fetch from '../../auth/FetchInterceptor';

export const getTickets = function (perPage, page) {
	return fetch({
		url: `/issues?perPage=${perPage}&page=${page}`,
		method: 'GET',
	});
};

export const getTicket = (id) => {
	return fetch({
		url: `/issues/${id}`,
		method: 'GET',
	});
};

export const createTicket = (data) => {
	return fetch({
		url: `/issues`,
		method: 'POST',
		data,
	});
};

export const commentTicket = (id, comment) => {
	return fetch({
		url: `/issues/${id}/comment`,
		method: 'POST',
		data: {
			comment,
		},
	});
};

export const resolveTicket = (id) => {
	return fetch({
		url: `/issues/${id}/resolve`,
		method: 'POST',
	});
};

export const addTicketAttachment = (id, attachment) => {
	const data = new FormData();
	data.append('file', attachment);

	return fetch({
		url: `/issues/${id}/attachment`,
		method: 'POST',
		data,
	});
};

export const getTicketAttachment = (id) => {
	return fetch({
		url: `/issues/attachment/${id}`,
		method: 'GET',
	});
};
